<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    v-if="dialog"
  >
    <popup-header
      @clickClose="closeModal()"
      :headerBg="'#cee5fd'"
    ></popup-header>

    <div class="member-profile overflow-y-auto">
      <v-row class="ma-0">
        <v-col cols="12" class="inner-wrap">
          <div class="avatar-wrap">
            <v-img :src="getImgSrc"></v-img>
          </div>
          <div class="profile-desc">
            <div class="name">{{ memberInfo.empName }}</div>
            <ul class="pa-0 info-desc">
              <li>{{ memberInfo.enterNm }}</li>
              <li>{{ memberInfo.orgNm }}</li>
            </ul>
            <div class="btn-wrap mt-5">
              <v-btn
                v-if="memberInfo.contPhone != null && !isShowEmployeeDialogBtn"
                color="#bed4ea"
                elevation="0"
                width="48"
                min-width="48"
                height="48"
                @click="callSms(memberInfo.contPhone.replace(/-/g, ''))"
                ><v-icon size="20" color="#363c43"
                  >mdi-message-processing-outline</v-icon
                ></v-btn
              >
              <v-btn
                v-if="memberInfo.contPhone != null"
                color="#bed4ea"
                elevation="0"
                width="48"
                min-width="48"
                height="48"
                @click="callTel(memberInfo.contPhone.replace(/-/g, ''))"
              >
                <v-icon size="25">mdi-cellphone-basic</v-icon>
                <!--<v-icon size="20" color="#363c43">mdi-phone-outline</v-icon>-->
              </v-btn>
              
              <v-btn
                v-if="memberInfo.contOffice !== null"
                color="#bed4ea"
                elevation="0"
                width="48"
                min-width="48"
                height="48"

                target="_parent"
                @click="callTel(memberInfo.contOffice.replace(/-/g, ''))"
              >
                <v-icon size="18">mdi-phone-classic</v-icon>
              </v-btn>

              <v-btn
                v-if="isShowEmployeeDialogBtn"
                color="#bed4ea"
                elevation="0"
                width="48"
                min-width="80"
                height="48"
                @click="openEmployeeRd(memberInfo)"
                target="_parent"
              >
                <!--v-icon size="20" color="#363c43"
                  >mdi-account-details-outline</v-icon
                -->인사카드
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row class="ma-0 mt-8">
        <v-col cols="12" class="profile-list-outer">
          <ul class="profile-list">
            <li>
              <span class="label">직위</span>
              <span class="desc">{{ memberInfo.jikweeNm }}</span>
            </li>
            <li>
              <span class="label">직책</span>
              <span class="desc">{{ memberInfo.jikchakNm }}</span>
            </li>
            <li>
              <span class="label">연락처</span>
              <span class="desc">{{ memberInfo.contPhone }}</span>
            </li>
            <li>
              <span class="label">사무실번호</span>
              <span class="desc">{{memberInfo.extOffice===undefined || memberInfo.extOffice===null?'':'('+memberInfo.extOffice+')'}}{{ memberInfo.contOffice }}</span>
            </li>
            <li>
              <span class="label">회사메일</span>
              <span class="desc">{{ memberInfo.contEmailIn }}</span>
            </li>
            <!--
            <li>
              <span class="label">생년월일</span>
              <span class="desc">{{
                memberInfo.bir !== null && memberInfo.bir !== undefined
                  ? memberInfo.bir.substring(0, 4) +
                    '-' +
                    memberInfo.bir.substring(4, 6) +
                    '-' +
                    memberInfo.bir.substring(6, memberInfo.bir.length2) +
                    memberInfo.bir2
                  : ''
              }}</span>
            </li>
            <li>
              <span class="label">입사일</span>
              <span class="desc">{{ memberInfo.empYmd }}</span>
            </li>
            -->
          </ul>
        </v-col>
      </v-row>
    </div>

    <v-dialog v-if="isShowEmployeeDialog" v-model="isShowEmployeeDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card height="100%">
        <v-toolbar fixed flat>
          <v-btn icon @click="isShowEmployeeDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn icon @click="firstPage">
            <v-icon>mdi-arrow-collapse-left</v-icon>
          </v-btn>
          <v-btn icon @click="prevPage">
            <v-icon>mdi-arrow-left-bold-circle</v-icon>
          </v-btn>
          <v-btn icon @click="nextPage">
            <v-icon>mdi-arrow-right-bold-circle</v-icon>
          </v-btn>
          <v-btn icon @click="lastPage">
            <v-icon>mdi-arrow-collapse-right</v-icon>
          </v-btn>
          <v-btn icon @click="zoomIn">
            <v-icon>mdi-magnify-plus-outline</v-icon>
          </v-btn>
          <v-btn icon @click="zoomOut">
            <v-icon>mdi-magnify-minus-outline</v-icon>
          </v-btn>
        </v-toolbar>
        <div id="crownix-viewer" style="width : 100%; margin-top : 44px;"></div>
      </v-card>

    </v-dialog>
  </v-dialog>
</template>

<script>
/* 직원 프로필 모달 */
import PopupHeader from '@/components/common/PopupHeader.vue'; // dialog Header component
import dialogMixin from '@/mixins/dialogMixin.js';
import {loadScript} from "vue-plugin-load-script"; // ** dialog Mixin **
import {encryptEmployee} from "@/api/rd";
import { mapGetters } from 'vuex';
import store from "@/store";

export default {
  mixins: [dialogMixin],

  props: {
    memberInfo: {
      type: Object,
    },
  },
  data: () => ({
    modalName: 'member_profile',
    viewer : null,
    isShowEmployeeDialog : false,
    isShowEmployeeDialogBtn : false
  }),
  computed: {
    ...mapGetters(['GET_USER_DATA']),
    getImgSrc() {
      // console.dir('profile item ::: ' + JSON.stringify(this.memberInfo));
      // console.log('profile item : ', this.memberInfo);
      return this.memberInfo.bFileNm !== null
        ? this.$domain + 'api/file/profile?fileName=' + this.memberInfo.bFileNm +'&enterCd=' + this.memberInfo.enterCd
        : /*
        this.$domain +
            '/cloudhr/1.0/file/display?fileId=' +
            this.memberInfo.fileId +
            '&seqNo=' +
            this.memberInfo.seqNo
        */
          require('@/assets/img/profile_none.png');
    },
  },
  components: {
    PopupHeader,
  },
  methods : {

    callSms(num) {
      window.bizMOB.System.callSMS({
        "_aNumber" : [num],
        "_sMessage" : "",
        "_fCallback" : function(res) {
          // console.log('callSms : '+JSON.stringify(res));
        }
      });
    },

    callTel(num) {
      window.bizMOB.System.callTEL({
        "_sNumber" : num,
        "_fCallback" : function(res) {
          // console.log(JSON.stringify(res));
        }
      });
    }

    , empInfoCardYnChk(){
      if (this.$store.getters.GET_USER_DATA.empInfoCardYn == 'Y') {
        this.isShowEmployeeDialogBtn = true; // 대표, HR, 시스템담당자
      }
    }
    , openEmployeeRd(info){
      if(!this.$store.getters.GET_SECOND_AUTHENTICATE){
        this.$store.commit('SET_SECOND_AUTHENTICATE_AFTER_TYPE', 'dialog');
        this.$store.commit('SET_SHOW_SECOND_AUTHENTICATE', true);
        return;
      }
      this.isShowEmployeeDialog = true;
      this.loadCrownix(info);
      // if(!this.$store.getters.GET_SECOND_AUTHENTICATE){
      //   this.$store.commit('SET_SHOW_SECOND_AUTHENTICATE', true);
      // }else{
      //   this.isShowEmployeeDialog = true;
      //   this.loadCrownix(info);
      // }
    }
    , loadCrownix(info){
      loadScript(
          process.env.VUE_APP_RD_URL + '/ReportingServer/html5/js/crownix-viewer.min.js',
          //'https://mhr.bgf.co.kr/ReportingServer/html5/js/crownix-viewer.min.js',
      ).then((e) => {
        // console.log('crownix loaded');
        this.getEncrypt(info);
      });
    }
    , getEncrypt(info){
      encryptEmployee({
        enterCd : info.enterCd
        , sabun : info.sabun
        , fileName : info.bFileNm
        , parameterType : ''
        , localCd : ''
      }).then((response) => {
        this.viewer = new window.m2soft.crownix.Viewer(
            process.env.VUE_APP_RD_URL + '/ReportingServer/service',
            //'https://mhr.bgf.co.kr/ReportingServer/service',
            'crownix-viewer',
        );
        this.viewer.setParameterEncrypt(11);
        this.viewer.openFile(response.data.path, response.data.encryptParameter, {showPageNum : 2});
        this.viewer.hideToolbar();
      });
    }
    , firstPage(){
      this.viewer.moveFirstPage();
    }
    , prevPage(){
      this.viewer.prevPage();
    }
    , nextPage(){
      this.viewer.nextPage();
    }
    , lastPage(){
      this.viewer.moveLastPage();
    }
    , zoomIn(){
      this.viewer.zoomIn();
    }
    , zoomOut(){
      this.viewer.zoomOut();
    }
  },
  mounted() {
    this.empInfoCardYnChk();
  },
};
</script>
<style>
.crownix-dialog-message:nth-child(2){
  display: block !important;
  position:absolute;
  top:70px;
}
.crownix-dialog-message:nth-child(3){
  display: none !important;
}
</style>
